import { createContext, type ReactNode } from 'react';
// Null in the shipping app. The isolated web preview supplies its own renderer.
export const ExistingPreviewContext = createContext<((name: string, children: ReactNode) => ReactNode) | null>(null);
